import React, { Fragment } from 'react';
import styles from './PricingTableSection.scss';
import { currencySigns } from 'lib/support';
import Section from './Section';

const PricingTableSection = (props) => {

  const pricingTableCategories= {
    Community: 'Auctions, Bars & Pubs, Charity, Fundraisers, Holidays, Libraries, Markets, Meditation & Yoga, Religion & Spiritual',
    Lifestyle: 'Arts & Leisure, Attractions, Dating, Gardening, Health & Fitness, Kids & Family, Pets & Animals, Retail, Talks & Lectures, Theatre, Travel',
    Entertainment: 'Ballet, Classes & Courses, Comedy, Dance, Fashion, Food & Drink, Galleries, Museums, Musicals, Nightlife, Live Music, Opera, Retail, Sports & Leisure, Theatre',
    Professional: 'Classes & Courses, Festivals, Meetings, Networking, Professional Training, Running, Workshops',
    Enterprise: 'Conference, Exhibitions, Tradeshows'
  };

  const convertToMoney = (amount) => {
    return parseFloat(amount).toLocaleString(undefined, {minimumFractionDigits: 2});
  };

  const {
    pricingTiers,
    subscriptionTiers,
    currency,
    backgroundColor,
    textColor,
    themeLightestBgColor } = props;

  return (
    <Section id="pricing-table-section" subtitle={<Fragment><span className="bolder">Buy credits, promote your events.</span> Prices are on a per event basis.</Fragment>}
      title="Pricing plans">
      <div className={styles.pricingTableDiv}>
        <span style={{backgroundColor: backgroundColor, color: textColor}}>
        Premium
        </span>
        <table className="table-responsive">
          <thead>
            <tr style={{backgroundColor: themeLightestBgColor}}>
              <th>Plans</th>
              <th>Categories</th>
              <th className="pricing-th">Free Event Listing</th>
              <th className="pricing-th">Premium</th>
              <th className="pricing-th">Premium Subscription <br/>
            (Min 4/Month)
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(pricingTableCategories).map((market, index) => {
              return (
                <tr key={market}>
                  <td>{market}</td>
                  <td className="categories">{pricingTableCategories[market]}</td>
                  <td className="free">Free</td>
                  <td className="value">
                    {currencySigns[currency]}
                    {convertToMoney(pricingTiers.get((index + 1).toString()).get('prices').get(currency).get('amount'))}
                  </td>
                  <td className="value">
                    {currencySigns[currency]}
                    {convertToMoney(subscriptionTiers.get((index + 1).toString()).get('prices').get(currency).get('amount'))}
                  </td>
                </tr>
              );
            })
            }
          </tbody>
        </table>
      </div>
    </Section>
  );
};

export default PricingTableSection;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/PricingTableSection.jsx